<template>
  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <button style="float: left; margin-top: -5px" type="button" class="btn btn-tool" data-toggle="collapse" href="#collapse1">
          <i class="fas fa-minus"></i>
        </button>
        <h5 class="card-title" id="accordion">Filtrar Comitentes</h5>
      </div>
      <div id="collapse1" class="collapse" data-parent="#accordion">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="nome">Nome</label>
                <input @keyup="buscarComitentes" class="form-control" id="nome" placeholder="Nome" v-model="nome" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select class="custom-select rounded-0" id="endereco_estado" v-model="estado" @change="buscarCidades()">
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="cidade" @change="buscarComitentes">
                  <option v-for="cidade in cidades" :key="cidade" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="cpf_cnpj">CPF/CNPJ</label>
                <input @keyup="buscarComitentes" class="form-control" id="cpf_cnpj" placeholder="CPF/CNPJ" v-model="cpf_cnpj" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="email">Email</label>
                <input @keyup="buscarComitentes" class="form-control" id="email" placeholder="Email" v-model="email" />
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco">Endereço</label>
                <input @keyup="buscarComitentes" class="form-control" id="endereco" placeholder="endereco" v-model="endereco" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="fone">Fone</label>
                <input @keyup="buscarComitentes" class="form-control" id="fone" placeholder="Fone" v-model="fone" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="nome_contato">Nome contato</label>
                <input @keyup="buscarComitentes" class="form-control" id="fone" placeholder="Nome contato" v-model="nome_contato" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE COMITENTES -->

    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Comitentes</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Nome</th>
              <th>Cidade/UF</th>
              <th>Contato</th>
              <th>Editar</th>
              <th>Deletar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(comitente, index) in comitentes" :key="comitente">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">{{ comitente.id }}</td>

              <td data-label="Nome" style="text-transform: uppercase">{{ comitente.nome }}</td>

              <td data-label="Cidade/UF" style="text-transform: uppercase">{{ comitente.cidade + "/" + comitente.estado }}</td>

              <td data-label="Contato" style="text-transform: uppercase">
                <strong>Nome:</strong>
                &nbsp;{{ comitente.nome }}
                <br />
                <strong>Email:</strong>
                &nbsp;
                <a style="text-transform: none">{{ comitente.email }}</a>
                <br />
                <strong>Fone:</strong>
                &nbsp;{{ comitente.fone }}
              </td>

              <td>
                <a :href="getUrlEdit(comitente)" type="button" class="btn btn-primary btn-sm">Editar</a>
              </td>

              <td>
                <button @click="deletar(comitente)" type="button" class="btn btn-danger btn-sm">Deletar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card-footer clearfix">
      <!-- TOTAIS  -->
      <div style="font-size: 13px" class="float-left" aria-live="polite">
        Exibindo do {{ inicio + 1 }} ao {{ inicio + comitentes.length }}
        <p>Total {{ total }}</p>
      </div>

      <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

      <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
        <option :value="200">200</option>
      </select>

      <div class="card-tools">
        <div class="input-group input-group-sm" style="width: 150px"></div>
      </div>

      <!-- PAGINAÇÃO  -->
      <ul class="pagination pagination-sm m-0 float-right">
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

        <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
          <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
            {{ pagina }}
          </a>
        </li>

        <li class="page-item">
          <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
        </li>
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
      </ul>
    </div>

    <div
      class="modal fade"
      id="detalhes-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      v-if="comitente_selecionado"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar documento por tipo de usuário</h4>
              <br />

              <div class="form-group">
                <label for="cadastro_tipo">Tipo cadastro</label>
                <select class="form-control" id="cadastro_tipo" v-model="comitente_selecionado.cadastro_tipo">
                  <option value="pf">PF</option>
                  <option value="pj">PJ</option>
                </select>
              </div>

              <div class="form-group">
                <label for="cadastro_tipo">Estado civil</label>
                <select class="custom-select rounded-0" id="estado_civil" v-model="comitente_selecionado.estado_civil">
                  <option value="uniao_estavel">União estável</option>
                  <option value="casado">Casado</option>
                  <option value="divorciado">Divorciado</option>
                  <option value="separado judicialmente">Separado judicialmente</option>
                  <option value="viuvo">Viuvo</option>
                  <option value="solteiro">Solteiro</option>
                </select>
              </div>
              <div class="form-group">
                <label for="tipo_doc">Tipo documento</label>
                <input class="form-control" id="tipo_doc" type="text" v-model="comitente_selecionado.tipodoc" />
              </div>

              <div class="form-group">
                <label for="obrigatorio">Obrigatório</label>
                <select class="form-control" id="obrigatorio" v-model="comitente_selecionado.obrigatorio">
                  <option :value="0">Sim</option>
                  <option :value="1">Não</option>
                </select>
              </div>

              <button data-toggle="modal" data-target="#detalhes-modal" type="button" class="btn btn-primary btn-sm">Voltar</button>

              <button class="btn btn-success btn-sm" @click="update()">
                Salvar
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      comitente_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      comitentes: [],
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      max_page: 0,
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.buscarComitentes();
  },

  methods: {
    getUrlEdit(comitente) {
      return "/admin/comitente/" + comitente.id;
    },

    show(comitente) {
      this.comitente_selecionado = comitente;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarComitentes();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarComitentes();
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarComitentes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarComitentes() {
      this.isLoading = true;

      let data = {
        cidade: this.cidade,
        estado: this.estado,
        cpf_cnpj: this.cpf_cnpj,
        nome: this.nome,
        inicio: this.inicio,
        email: this.email,
        fone: this.fone,
        endereco: this.endereco,
        nome_contato: this.nome_contato,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarComitentes();
    },

    deletar(comitente) {
      this.comitente_selecionado = comitente;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o comitente<b><br/>" + this.comitente_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.comitente_selecionado.id,
            };

            axios
              .post(`/admin/comitente/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Comitente deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.comitente_selecionado.id,
        cadastro_tipo: this.comitente_selecionado.cadastro_tipo,
        tipodoc: this.comitente_selecionado.tipodoc,
        estado_civil: this.comitente_selecionado.estado_civil,
        obrigatorio: this.comitente_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
